import type { FunctionComponent } from 'react';
import { Container } from '@lmn/common-search-widget';
import styled from 'styled-components';
import { UBUNTU_FONT_STACK } from '@/utils/ubuntuFont';
import type { CSWProps } from './services/types';
import useConfiguration from './services/useConfiguration';
import useTabs from './services/useTabs';
import useInteractionEvents from './services/useInteractionEvents';
import ErrorBoundary from '../components/ErrorBoundary';

const FontWrapper = styled.div`
  && * {
    font-family: ${UBUNTU_FONT_STACK};
  }
`;

const CSW: FunctionComponent<CSWProps> = (props) => {
  useInteractionEvents();

  const configuration = useConfiguration();
  const tabs = useTabs(props);
  const { ssrUtils } = props;

  return (
    <ErrorBoundary id="CSW">
      <FontWrapper>
        <Container configuration={configuration} tabs={tabs} ssrUtils={ssrUtils} />
      </FontWrapper>
    </ErrorBoundary>
  );
};

export default CSW;
